import React from 'react'

import classNames from 'classnames'

import Container, { gutterTypes } from '~/components/atoms/Container/Container'
import Fixture from '~/components/atoms/Fixture/Fixture'
import { urlFor } from '~/components/atoms/Image/Image'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import VideoEmbed from '~/components/atoms/VideoEmbed/VideoEmbed'
import type { ComponentTheme } from '~/components/themes'
import type { TArticleVideo } from '~/pages/[lang]/edition/[category]/[articleTaxonomy]/[slug]'

import styles from './SingleVideoModule.module.css'

export interface SingleVideoModuleProps {
  variant?: ComponentTheme.black
  title: string
  summary: string
  video: TArticleVideo[] | TArticleVideo
  testID?: string
  moduleId?: string
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  offWhiteBackground?: boolean
  withContainer?: boolean
  autoPlay?: boolean
}

const VideoContent = ({
  title,
  summary,
  videoUrl,
  image,
  testID,
  autoPlay = false,
}: {
  title?: string
  summary?: string
  videoUrl: string
  image?: string
  testID?: string
  autoPlay?: boolean
}) => (
  <div className={styles.base} data-testid={testID}>
    {title && summary && (
      <div className={styles.head}>
        <Text
          Tag="h2"
          size={TextSizes.primaryTitleMed}
          className={styles.title}
          uppercase
        >
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </Text>
        <Text
          Tag="h3"
          size={TextSizes.secondaryTitleLrg}
          className={styles.summary}
        >
          {summary}
        </Text>
      </div>
    )}
    <div className={styles.playerWrapper}>
      <VideoEmbed
        videoSrc={videoUrl}
        videoType="youtube"
        customThumbnail={image}
        autoPlay={autoPlay}
      />
    </div>
  </div>
)

export default function SingleVideoModule({
  variant,
  title = '<em>My</em>ArtBroker Talks',
  summary,
  video,
  testID,
  moduleId,
  verticalPadding = true,
  noPaddingBottom = false,
  offWhiteBackground = false,
  withContainer = true,
  autoPlay = false,
}: SingleVideoModuleProps) {
  const { coverImage, videoUrl } = Array.isArray(video) ? video[0] : video
  const image = coverImage && urlFor(coverImage, 1000)

  const content = (
    <VideoContent
      title={title}
      summary={summary}
      videoUrl={videoUrl}
      image={image}
      testID={testID}
      autoPlay={autoPlay}
    />
  )

  return (
    <Fixture
      theme={variant}
      id={moduleId}
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
      className={classNames({
        [styles.offWhiteBackground]: offWhiteBackground,
      })}
    >
      {withContainer ? (
        <Container gutters={gutterTypes.always}>{content}</Container>
      ) : (
        content
      )}
    </Fixture>
  )
}
